import React, { Component } from "react";
import CustomBoardRenewal from "../../../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import Grid from "@material-ui/core/Grid";
import CustomButton from "../../../../components/CustomButton";

class PayRenewalUnsuccessful extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onClickRetryRenewal = () => {
    const { history } = this.props;
    history.push("/OnlineRenewal");
  };

  renderChildren = () => {
    const { classes } = this.props;

    return (
      <Grid container direction={"column"} spacing={2}>
        <Grid item>
          <CustomText
            design={classes.renewNowTextStyle}
            style={{ color: "#2c3034" }}
          >
            Renewal Unsuccessful
          </CustomText>
        </Grid>

        <Grid item>
          <Grid container direction={"column"} spacing={3}>
            <Grid item>
              <CustomText>Your payment is not successful.</CustomText>
            </Grid>

            <Grid item>
              <CustomText>Please try again.</CustomText>
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <CustomButton
            title={"Retry Renewal"}
            design={classes.retryRenewalButton}
            textstyle={classes.buttonTextStyle}
            onClick={this.onClickRetryRenewal}
          />
        </Grid>
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoardRenewal
          children={this.renderChildren()}
          height={height}
          width={width}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  checkButtonStyle: {
    height: 40,
    fullWidth: true,
    marginTop: 10,
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
    marginBottom: 10,
  },
  retryRenewalButton: {
    width: 160,
    marginTop: 10,
  },
});

export default withStyles(styles, { withTheme: true })(
  withRouter(PayRenewalUnsuccessful)
);
